module.exports = __webpack_public_path__ + "img/fjern.5bb7447b.svg";